/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zusatzbogenschuleversendet2Inputs */

const de__field_zusatzbogenschuleversendet2 = /** @type {(inputs: _Field_Zusatzbogenschuleversendet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzbogen Schule versendet`)
};

/**

* @param {_Field_Zusatzbogenschuleversendet2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zusatzbogenschuleversendet2 = /** @type {((inputs?: _Field_Zusatzbogenschuleversendet2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zusatzbogenschuleversendet2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zusatzbogenschuleversendet2(inputs)
});
export { _field_zusatzbogenschuleversendet2 as "_field_zusatzbogenSchuleVersendet" }